export default "__VITE_ASSET__BukNhSUR__"